/* eslint-disable jsx-quotes */
import React from 'react';
import moment from 'moment';

import ConfirmationModal from '../../../modals-components/ConfirmationModal';

import './ItemTest.css';

export default class ItemTestPresentation extends React.Component {
    constructor(props) {
        super(props);
    }

    getTypeTest({ type }) {
        switch (type) {
            case 'FORMACAO':
                return 'Formação';
            case 'MASTER':
                return 'Master';
            case 'UNIFICADO':
                return 'Unificado';
            default:
                return 'Não identificado';
        }
    }

    getStatusTest({ status }) {
        switch (status) {
            case 'INCOMPLETE':
                return 'Incompleto';
            case 'READY':
                return 'Completo';
            case 'READY_WITH_COMPLETION':
                return 'Completo Respondido';
            case 'LINKED':
                return 'Vinculado';
            case 'LINKED_WITH_COMPLETION':
                return 'Vinculado Respondido';
            default:
                return 'Não identificado';
        }
    }

    render() {
        const {
            test,
            showContent,
            handleShowContent,
            gotoManageQuestion,
            showModalRemoveTest,
            handlePortalRemove,
            handleConfirmRemove,
            gotoDuplicateQuestion,
        } = this.props;
        return (
            <div className="container-item-test">
                <div className="table-grid-line">
                    <span>
                        <p>{test.label}</p>
                    </span>
                    <span>
                        <p>
                            {this.getTypeTest({
                                type: test.test_type,
                            })}
                        </p>
                    </span>
                    <span>
                        <p>
                            {' '}
                            {this.getStatusTest({
                                status: test.status,
                            })}
                        </p>
                    </span>
                    <span>
                        <p>{test.questions_per_test}</p>
                    </span>
                    <span>
                        <p>{test.approval_percent}%</p>
                    </span>
                    <span>
                        <p>{moment(test.created_at).format('DD/MM/YYYY')}</p>
                    </span>
                    <span>
                        <p>{moment(test.updated_at).format('DD/MM/YYYY')}</p>
                    </span>
                    <span>
                        <button
                            onClick={() =>
                                handleShowContent({
                                    newValue: showContent ? false : true,
                                })
                            }
                        >
                            {showContent ? 'Ocultar' : 'Detalhes'}
                        </button>
                    </span>
                </div>
                {showContent && (
                    <section className="container-details-template-test">
                        <p className="title-modal">Detalhes do teste</p>
                        <div className="content-test">
                            <strong className="title-label">
                                {test.label}
                            </strong>

                            <div>
                                <p className="description-item">
                                    <strong>
                                        Quantidade mínima de opções:
                                    </strong>{' '}
                                    {test.min_options}
                                </p>
                                <p className="description-item">
                                    <strong>
                                        Quantidade máxima de opções:
                                    </strong>{' '}
                                    {test.max_options}
                                </p>
                                <p className="description-item">
                                    <strong>Duração máxima:</strong>{' '}
                                    {test.max_duration
                                        ? test.max_duration / 60
                                        : 0}{' '}
                                    minutos
                                </p>
                            </div>
                        </div>
                        <span className="line-buttons-details">
                            <button
                                className="manage-test-btn"
                                type="button"
                                onClick={() => gotoManageQuestion(test.id)}
                            >
                                Editar teste
                            </button>
                            <button
                                className="remove-test-btn"
                                onClick={() =>
                                    handlePortalRemove(showModalRemoveTest)
                                }
                                type="button"
                            >
                                Remover
                            </button>
                            {/* <button
                                disabled={test.status === 'INCOMPLETE'}
                                className={`duplicate-test-btn ${
                                    test.status === 'INCOMPLETE'
                                        ? 'disable-btn'
                                        : ''
                                }`}
                                onClick={() => gotoDuplicateQuestion(test.id)}
                                type="button"
                            >
                                Duplicar
                            </button> */}
                        </span>

                        {showModalRemoveTest && (
                            <ConfirmationModal
                                handleClickOutPortal={() =>
                                    handlePortalRemove(showModalRemoveTest)
                                }
                                handleConfirm={() =>
                                    handleConfirmRemove(test.id)
                                }
                                message={'Deseja remover esse teste?'}
                            />
                        )}
                    </section>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tests/components/ItemTest/ItemTestPresentation.js